import { IconCircle, SectionHeader } from "./shared";
import iconRupee from "../../assets/home/icon-rupee.svg";
import iconUser from "../../assets/home/icon-user.svg";
import iconFile from "../../assets/home/icon-file.svg";
import iconGear from "../../assets/home/details-gear.svg";
import iconBadge from "../../assets/home/details-badge.svg";

const DETAILS: { label: string; value: string; desc?: string; icon: string | null }[] = [
  { label: "Loan Amount", value: "₹5,000–₹50,000", desc: "Access dynamic credit limits adjusted for you. Final amount subject to eligibility and assessment.", icon: iconRupee },
  { label: "Repayment Tenure", value: "61–90 days", desc: "Repayment period is subject to applicable eligibility and assessment criteria.", icon: iconUser },
  { label: "Interest Rate", value: "3% per 30-day period", desc: "Interest rate: 3% per 30-day period. Interest calculation basis: [To be confirmed].", icon: null },
  { label: "Processing Fee", value: "Up to 10%", icon: iconFile },
  { label: "APR", value: "Up to 35% (Fixed)", icon: iconGear },
  { label: "Applicable Charges", value: "GST Exclusive", icon: iconBadge },
];

export default function HomeLoanDetails() {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-[80px] py-[60px]">
      <div className="max-w-[1280px] mx-auto flex flex-col gap-10 lg:gap-14">
        <SectionHeader badge="Loan Details" title="Loan Details at a Glance" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
          {DETAILS.map((d) => (
            <div key={d.label} className="flex flex-col gap-4 bg-[#f8fafc] border border-[#f3f4f6] rounded-[24px] p-6 sm:p-8">
              <div className="flex items-center gap-2">
                <IconCircle size={32}>
                  {d.icon ? (
                    <img alt="" src={d.icon} className="size-4" />
                  ) : (
                    <span className="font-light text-[#5b168c] text-[18px] leading-none">%</span>
                  )}
                </IconCircle>
                <span className="font-extrabold text-[#5b168c] text-[14px] tracking-[0.5px] uppercase whitespace-nowrap">{d.label}</span>
              </div>
              <p className="font-bold text-[#1a1a4b] text-[22px]">{d.value}</p>
              {d.desc && <p className="text-[#6a7282] text-[13px] leading-[18px]">{d.desc}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
